import { Box, Card, CardHeader, Link, Stack, styled } from '@mui/material';
import { PropsWithChildren } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { StyledCardContent } from '../../components/containers/StyledCardContent';
import { brandConfig } from '../../config';
// ----------------------------------------------------------------------

export default function LoginLayout({ children }: PropsWithChildren) {
  const logoUrl = brandConfig.loginLogo;

  return (
    <>
      <StyledBackground />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={1}
        height={1}
        flexGrow={1}
        style={{ backdropFilter: 'blur(6px)' }}
      >
        <Card raised sx={{ width: { sm: 400, xs: 350 } }}>
          <CardHeader
            disableTypography
            sx={{
              pt: { xs: 3, sm: 4 },
              pb: { xs: 2, sm: 3 },
              px: 3,
            }}
            title={
              <Link
                component={RouterLink}
                to="/"
                underline="none"
                sx={{
                  display: 'block',
                  width: '100%',
                  '&:focus': {
                    outline: 'none',
                  },
                  '&:focus-visible': {
                    outline: 2,
                    outlineOffset: 2,
                    outlineStyle: 'solid',
                    outlineColor: 'primary.main',
                    borderRadius: 1,
                  },
                }}
              >
                <Box
                  component="img"
                  src={logoUrl}
                  alt={brandConfig.name}
                  sx={{
                    width: 1,
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
              </Link>
            }
          />
          <StyledCardContent sx={{ pt: 0 }}>
            <Stack className="login-content" sx={{ width: 1 }}>
              {children}
            </Stack>
          </StyledCardContent>
        </Card>
      </Box>
    </>
  );
}

//----------------
const StyledBackground = styled('div')(({ theme }) => ({
  backgroundImage: `url(${brandConfig.backgroundUrl})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: -1,
}));
